import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { Spin } from 'antd';
import Modal from 'antd/lib/modal';
import classNames from 'classnames';

import { useCtx } from 'one-ui-provider';

import Table from "antd/lib/table";
import Skeleton from 'antd/lib/skeleton';
import {
  selectAction,
} from 'one-state-source-local';

import {
  setAction as setSkeletonAction
} from 'one-state-skeleton';
import { 
  PatientMatchType,
  PatientMatchFrom,
  setMatchTypeAction as setPatientMatchTypeAction,
  setMatchFromAction as setPatientMatchFromAction
} from 'one-state-patient-match';
import {
  setSelectedAction,
  setPatientSelectedAction,
} from 'one-state-subject/src/actions';

import {
  setAction as globalSearchAction,
} from 'one-state-patient-global-search';

import {
  setAction as sourceSearchAction,
} from 'one-state-sourcesearch';

import {
  VerifyFlowProps
} from './props';

import {
  OneVerifyModal
} from './model';
import PhoneIncoming from '@2fd/ant-design-icons/lib/PhoneIncoming';
import BadgeAccount from '@2fd/ant-design-icons/lib/BadgeAccount';
import HumanChild from '@2fd/ant-design-icons/lib/HumanChild'
import HumanFemale from '@2fd/ant-design-icons/lib/HumanFemale'
import HumanMale from '@2fd/ant-design-icons/lib/HumanMale'
import MotherNurse from '@2fd/ant-design-icons/lib/MotherNurse'
import Doctor from '@2fd/ant-design-icons/lib/Doctor'

import Check from '@2fd/ant-design-icons/lib/Check';
import Magnify from '@2fd/ant-design-icons/lib/Magnify';
import { Disposition } from 'one-model-local';
import Floater from "react-floater";

export const setSourcePatientColumns = (filters: any, PatientOnSelect: any) => {
    let patient_source_columns = [];
    const {
      name_display,
      callertype_display,
      age_display,
      address_display,
      dob_display,
      zipcode_display,
      gender_display,
    } = filters;
    if(name_display){
      patient_source_columns.push(
        {
              title: 'Patients',
              dataIndex: 'patient',
              width: 160,
              render: (props: any) => <b>{props}</b>,
        },
      )
    }
    if(callertype_display){
      patient_source_columns.push(
        {
              title: 'Type',
              dataIndex: 'type',
              width: 100,
        },
      )
    }
    if(age_display){
      patient_source_columns.push(
        {
              title: 'Age',
              dataIndex: 'age',
              width: 50,
        },
      )
    }
    if(dob_display){
      patient_source_columns.push(
        {
              title: 'Date Of Birth',
              dataIndex: 'birthday',
              width: 100,
        },
      )
    }
    if (gender_display) {
      patient_source_columns.push(
        {
              title: 'Gender',
              dataIndex: 'gender',
              width: 100,
        },
      )
    }
    if(zipcode_display){
      patient_source_columns.push(
        {
              title: 'Postal Code',
              dataIndex: 'zip',
              width: 100,
        },
      )
    }
    if(address_display){
      patient_source_columns.push(
        {
              title: 'Location',
              dataIndex: 'location',
              width: 200,
        },
      )
    }
    patient_source_columns.push(
      {
            title: '',
            dataIndex: 'checked',
            width: 50,
            render: (value:any, row:any, index:any) => {
              return (
                <div className={`p-verification__check ${classNames({ 'is-active': row.selected })}`}>
                  <Check onClick={ ()=> PatientOnSelect(row, true)}/>
                </div>
              )
            },
      },
    )
    return patient_source_columns;
}

export const setSourceProviderColumns = (filters: any, ProviderOnSelect: any) => {
    let provider_columns = [];
    const {
      name_display,
      callertype_display,
      address_display
    } = filters;
    if(name_display){
      provider_columns.push(
        {
              title: 'Providers',
              dataIndex: 'providers',
              width: 200,
              render: (props: any) => <b>{props}</b>,
        },
      )
    }
    if(callertype_display){
      provider_columns.push(
        {
              title: 'Type',
              dataIndex: 'type',
              width: 120,
        },
      )
    }
    if(address_display){
      provider_columns.push(
        {
              title: 'Location',
              dataIndex: 'location',
              width: 200,
        },
      )
    }
    provider_columns.push(
      {
            title: '',
            dataIndex: 'checked',
            render: (value:any, row:any, index:any) => {
              return (
                <div className={`p-verification__check ${classNames({ 'is-active': row.selected })}`}>
                  <Check onClick={() => ProviderOnSelect(row, true)}/>
                </div>
              )
            },
      },
    )
    return provider_columns;
}

export const setSubjectPatientColumns = (filters: any, PatientOnSelect: any) => {
    let patient_columns = [];
    const {
      name_display,
      dob_display,
      age_display,
      address_display,
      zipcode_display,
      lastfourssn,
      mrn_display,
      gender_display,
    } = filters;

    if(name_display){
      patient_columns.push(
        {
              title: 'Patients',
              dataIndex: 'patient',
              width: 180,
              render: (props: any) => <b>{props}</b>,
        },
      )
    }
    if(dob_display){
      patient_columns.push(
        {
              title: 'Date Of Birth',
              dataIndex: 'birthday',
              width: 100,
        },
      )
    }
    if (gender_display) {
      patient_columns.push(
        {
              title: 'Gender',
              dataIndex: 'gender',
              width: 100,
        },
      )
    }
    if(age_display){
      patient_columns.push(
        {
              title: 'Age',
              dataIndex: 'age',
              width: 50,
        },
      )
    }
    if(zipcode_display){
      patient_columns.push(
        {
              title: 'Postal Code',
              dataIndex: 'zip',
              width: 100,
        },
      )
    }
    if(lastfourssn){
      patient_columns.push(
        {
              title: 'SSN',
              dataIndex: 'ssn',
              width: 100,
        },
      )
    }
    if(address_display){
      patient_columns.push(
        {
              title: 'Location',
              dataIndex: 'location',
              width: 200,
        },
      )
    }
    if(mrn_display){
      patient_columns.push(
        {
          title: 'MRN',
          dataIndex: 'mrn',
          width: 100,
        },
      )
    }
    patient_columns.push(
      {
            title: '',
            dataIndex: 'checked',
            width: 50,
            render: (value:any, rowdata:any, index:any) => {
              return (
                <div className={`p-verification__check ${classNames({ 'is-active': rowdata.selected })}`}>
                  <Check onClick={ ()=> PatientOnSelect(rowdata, true)}/>
                </div>
              )
            },
      },
    )

      return patient_columns;
}


export const NewVerifyFlow = <M extends OneVerifyModal>(
  props: VerifyFlowProps<M>
) => {
  const {
    model,
    skeleton,
  } = props;
  const {
    subjects,
    subjectselcted,
    source,
    choosecaller
  } = model;

  const { desktop } = useCtx();
  const Desktop = desktop;
  

  const wxccInteraction = useSelector((state: any) => (state.wxccInteraction));
  const [wxccInteractionId, setWxccInteractionId] = useState<any>('');

  useEffect(() => {
    if (contact_center_type && contact_center_type === 'wxcc') {
      init();
      subscribeAgentContactDataEvents();
      checkActiveCallInIdentifyFlow();
    }
  }, []);

  useEffect(() => {
    if (contact_center_type && contact_center_type === 'wxcc' 
        && wxccInteraction?.wxccInteractionId 
        && wxccInteractionId !== wxccInteraction?.wxccInteractionId) {
      setWxccInteractionId(wxccInteraction?.wxccInteractionId);
    }
  }, [wxccInteraction]);

  async function init() {
    await Desktop.config.init();
  }

  const subscribeAgentContactDataEvents = () => {
    Desktop.agentContact.addEventListener(
      "eAgentOfferContact",
      (msg: Service.Aqm.Contact.AgentContact) => {
        setWxccInteractionId(msg.data.interactionId);
      }
    );
  }

  const checkActiveCallInIdentifyFlow = async () => {
    try {
      //Fetching taskMap Object from WxCC Desktop Event
      const taskMap: any = await Desktop.actions.getTaskMap();
      log.debug('checkActiveCallInIdentifyFlow taksMap object', taskMap);
      //Check whether it is Active call by checking the size is > 0
      if (taskMap && taskMap?.size > 0) {
        log.debug('checkActiveCallInIdentifyFlow taksMap object size', taskMap?.size);
        //Fetch the taskMap Object value from Map Object
        const taskMap_Value = taskMap.values();
        log.debug('checkActiveCallInIdentifyFlow taksMap object value', taskMap_Value);
        const taskMap_Next_Value = taskMap_Value.next().value;
        log.debug('checkActiveCallInIdentifyFlow interactionId value', taskMap_Next_Value?.interactionId);
        setWxccInteractionId(taskMap_Next_Value?.interactionId);
      }
    } catch (e) {
      log.error('Failed to checkActiveCallInIdentifyFlow Exception:', e);
    }
  }

  async function setSubjectIdWxccCallVariable(subjectId: any) {
    try {
      const updatedSubjectIdCallVariable = await Desktop.dialer.updateCadVariables({
        interactionId: wxccInteractionId,
        data: {
          attributes: {
            subjectId: subjectId
          }
        }
      });
      log.debug('updatedSubjectIdCallVariable::', updatedSubjectIdCallVariable);
    } catch (e) {
      log.debug('Exception in Settings setSubjectIdWxccCallVariable', e)
    }
  }

  async function setSourceIdWxccCallVariable(sourceId: any) {
    try {
      const updatedSourceIdCallVariable = await Desktop.dialer.updateCadVariables({
        interactionId: wxccInteractionId,
        data: {
          attributes: {
            sourceId: sourceId
          }
        }
      });
      log.debug('setSourceIdWxccCallVariable::', updatedSourceIdCallVariable);
    } catch (e) {
      log.debug('Exception in Settings setSourceIdWxccCallVariable', e)
    }
  }

  const dispatch = useDispatch();
  const [steps, setSteps] = useState(0);
  const [skipsource,setSkipSource] = useState(false);
  const [selectedpatient,setSelectedPatient]= useState<any>({})
  const [isLoading, setIsLoading] = useState(false);
  const {settings, log, agentId} = useCtx();
  const {uisettings, updatepv, compatible } = settings;
  const { contact_center_type, patientverification_position, consolidated_api_invocation } = compatible;
  const {search,btg_config} = uisettings;
  const {btgenable} = btg_config;
  const sourcesearchstate = useSelector((state: any) => (state.sourcesearchdata));
  const btgpatient = useSelector((state: any) => (state.bgtpatient));
  const {verify_subject, verify_source: {verify_patient, verify_provider}, verification_model_width,preferred_name}=uisettings;

  const selectedPatientFunction = (selectedPatient: any)=> {
    dispatch(sourceSearchAction(false))
    setSteps(2);

    if (consolidated_api_invocation) {
      dispatch(setPatientSelectedAction(selectedPatient));
    }
    else {
      dispatch(setSelectedAction(selectedPatient));
    }
    //   dispatch(selectAction(event.id))
    let patientmodelskeleton = {
        upcomingAppts_skeleton: true,
        pendingReferrals_skeleton: true,
        pendingBills_skeleton: true,
        insurance_skeleton: true,
        pendingCare_skeleton: true,
        pharmacies_skeleton: true,
        source_skeleton: false,
        callingDestination_skeleton: false,
        subject_skeleton: false,
    }
    dispatch(setSkeletonAction(
        patientmodelskeleton
    ));
    // Make patient as verified after selection from patient modal menu
    dispatch({
        type: "one-state-patient-verified/set",
        payload: {
            verified: true,
        }
    });
    dispatchdata();
    sessionStorage.setItem("subjectid", selectedPatient?.id);
    //((updatepv?.subjectid) && (updatepv?.subjectid!= "")) && (UpdatePVvalue('subjectid', selectedPatient?.id, actions, settings, log));
    // if (contact_center_type && contact_center_type === 'five9') {
    //   var interactionApi = window.Five9.CrmSdk.interactionApi();
    //   var crmApi = window.Five9.CrmSdk.crmApi();
    //   interactionApi.getCav({interactionId}).then(function (cavList: any) {
    //     console.log('IframeV4 got cavList: ' + JSON.stringify(cavList));
    //     let five9subjectid = sessionStorage.getItem("five9_subject_id");
    //     interactionApi.setCav({
    //         interactionId,
    //         cavList: [{id: five9_subject_id ?  five9_subject_id : five9subjectid, name: "subjectid", group: "Patient", type: "STRING", value:selectedPatient?.id}]
    //     }).then(function (response: any) {
    //       console.log({setSubjectIdCavResponse: response});
    //       interactionApi.getCav({interactionId}).then(function (cavList: any) {
    //         console.log('IframeV5 got cavList: ' + JSON.stringify(cavList));
    //       })
    //     })
    //   })
    //   let crmSubjectObject = {id: selectedpatient?.id, label: "Subject", name: selectedpatient?.name, isWho: true, isWhat: false};
    //   let crmSSNObject = {id: selectedpatient?.ssn, label: "SSN", name: selectedpatient?.ssn, isWho: false, isWhat: true};
    //   crmApi.objectVisited({crmObject: crmSubjectObject});
    //   crmApi.objectVisited({crmObject: crmSSNObject});
    // }
    //Reset the hook after the functtion call.
    setSelectedPatient({})
  }
  // To check whether the Patient is a BTG patient or not.
  useEffect(() => {
    if (choosecaller?.visible) {
      //To Check if we get error for PatientSearch API
      if (Object.keys(btgpatient).length > 0 && btgpatient?.error && Object.keys(btgpatient.error).length > 0 && btgenable) {
        //We will show an error notification on the Dashboard
      }
      //Check if the ResourceType is OperationOutcome  then it is a BTG Patient.
      else if (btgpatient?.patientbtgdata?.resourceType === "OperationOutcome" && btgenable) {
        //We will show an error notification on the Dashboard
      }
      //If the ResourceType value is Patient then it is a non-BTG Patient.
      else if ((btgpatient?.patientbtgdata?.resourceType === "Patient" && btgenable)) {
        selectedPatientFunction(selectedpatient);
      }
    }
  }, [btgpatient]);

  const ProviderOnSelect = (row:any, onSelect: boolean) => {
    if(onSelect){
    if(skipsource){
      // do nothing
  }
  else {
      setSteps(1);
      const selected = sourcemodaldata?.find(
          (item: any) => item.id === row.id
      );
      dispatch(
          selectAction(selected?.id)
      )
      if(!choosecaller.start) {
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
              number: choosecaller.number,
              dnis: choosecaller.dnis,
              visible: false
          }
      });
      }
      sessionStorage.setItem("sourceid", selected?.id);
      //((updatepv?.sourceid) && (updatepv?.sourceid!= "")) && (UpdatePVvalue('sourceid', selected?.id, actions, settings, log));
      //Dispostion Implementation
      if (updatepv?.sourceid && updatepv?.sourceid != "") {
        let disp: Disposition = { value: "172" }
        disp.dial_list_uid = choosecaller?.callId;
        disp.meta00 = agentId;
        disp.meta01 = selected?.id;
        disp.meta02 = selected?.id;
        disp.meta03 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        })
      }
    }
  }
  }
  const PatientOnSelect = (row:any, onSelect: boolean) => {
    if (onSelect) {
       //Reset the error reducer
      dispatch({
        type:"one-state-error/reinit"
      })
      let selected = subjects.find(
        ((patient: any) => patient.id === row.id)
    );
    if (steps == 0) {
        setSteps(1);
        if (!selected) {
        selected = sourcepatientmodaldata?.find(
                (item: any) => item.id === row.id
            );
        }
        //If source is there not adding it to redux store as we already have it.
        let isthere = source?.values?.find(
          ((patient:any) => patient?.id === selected?.id)
        );
        //If its a patient it will add for the first time and if again you select same patient it will skip.
        if (!isthere) {
          dispatch({
            type: "one-state-source/add",
            payload: selected
          });
        }
        dispatch(
            selectAction(selected?.id)
        )
        if (choosecaller?.start === false) {
          dispatchdata();
        }
        sessionStorage.setItem("sourceid", selected?.id);
        //((updatepv?.sourceid) && (updatepv?.sourceid != "")) && (UpdatePVvalue('sourceid', selected?.id, actions, settings, log));
        //Dispostion Implementation
        if (updatepv?.sourceid && updatepv?.sourceid != "") {
          let disp: Disposition = { value: "172" }
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = agentId;
          disp.meta01 = selected?.id;
          disp.meta02 = selected?.id;
          disp.meta03 = 'client';
          dispatch({
            type: "store-disposition-code",
            payload: disp
          })
        }
    }
    else if (steps === 1 && sourcesearchstate.show) {
      dispatch(sourceSearchAction(false))
    }
    else {
       // for disposition matching type
       let disp: Disposition = { value: "" };
       if (subjects?.length > 1) { // multi match
         dispatch(setPatientMatchTypeAction(PatientMatchType.MULTI_MATCH));
         disp.value = '2000';
         disp.meta00 = agentId;
         disp.meta01 = selected?.id;
         disp.meta02 = choosecaller?.number
       } else { // single match
         dispatch(setPatientMatchTypeAction(PatientMatchType.SINGLE_MATCH));
         disp.value = '2001';
         disp.meta00 = agentId;
         disp.meta01 = selected?.id;
         disp.meta02 = choosecaller?.number
       } 
       dispatch({
         type: "store-disposition-code",
         payload: disp
       });
 
      if(btgenable) {
        setIsLoading(true);
        //Dispatch to check whether selected patient is a BTG Patient or not.
        dispatch({
          type: "one-state-btgpatient/fetch",
          payload: {
            name: selected.lastname,
            dob: selected.dob,
            given: selected.firstname,
            identifier: selected.id,
            telecom: selected.contact
          }
        })
        setSelectedPatient(selected)
      }
      else {
        selectedPatientFunction(selected)
      }
    }
    }
  }

  let patientcolumns: any = [];
  patientcolumns = setSubjectPatientColumns(verify_subject, PatientOnSelect);
  let providercolumns: any = [];
  providercolumns = setSourceProviderColumns(verify_provider, ProviderOnSelect);
  let sourcepatientcolumns: any = [];
  sourcepatientcolumns = setSourcePatientColumns(verify_patient, PatientOnSelect);



  //To avoid code smell
  const dispatchdata = () => {
    dispatch({
      type: "one-state-choosecaller/set",
      payload: {
          number: choosecaller.number,
          dnis: choosecaller.dnis,
          visible: false
      }
  });
  }

  // clear the selection on call reset
  useEffect(() => {
    if (choosecaller.start) {
      setSteps(0);
    } else {
      if(choosecaller.type === "provider") {
        setSteps(0);
        setSkipSource(false);
      }
      if(choosecaller.type === "patient") {
        setSkipSource(true);
        setSteps(1);
        dispatch(sourceSearchAction(false));
      }
      //
    }
    if (choosecaller.visible === false) {
      setIsLoading(false);
    }
  }, [choosecaller]);

  useEffect(() => {
    if (choosecaller?.visible) {
      if (btgpatient?.error?.status >= 400 || btgpatient?.error?.type == "error" || btgpatient?.patientbtgdata?.resourceType == "OperationOutcome") {
        setIsLoading(false);
      }
    }
  }, [btgpatient])
  //Build values for the Source table
  let sourcemodaldata: any = [];
  let sourcepatientmodaldata: any = [];

  if (source?.values.length > 0) {
    source.values.forEach((data: any) => {
      let selected=false;
      if(source.selected && source.selected.id===data.id){
        selected=true;
      }
      const info = {
        providers: data?.firstname,
        patient: data?.firstname ? data.firstname : "",
        type: data?.subtypename ? data.subtypename : "",
        location: data?.address ? data.address : "",
        zip: "",
        age: "",
        id: data?.id,
        birthday: data?.dob ? data?.dob : "",
        key: data?.id,
        selected:selected,
        gender: data?.gender ? data.gender : "",
      }
      if (data?.typename === "Provider") {
        sourcemodaldata.push(info);
      }
      if (data?.typename === "Patient") {
        sourcepatientmodaldata.push(info);
      }
    })
  }

    //Build Values for the Patient Table
    let patientmodaldata: any = [];
    let searcheddata = sessionStorage.getItem("PatientName");
    if (subjects?.length > 0) {
      subjects.forEach((patientdata: any) => {
        const dateOfBirth =patientdata?.dob ? patientdata.dob : "";
        let tempsubjectselected=false;
        let tempsourceselected=false;
        if(subjectselcted && subjectselcted.id===patientdata.id){
          tempsubjectselected=true;
        }
        let name=patientdata?.name
        let pName=name+" "+((preferred_name)&&(patientdata?.preferredName)?'"'+patientdata?.preferredName+'"':'')
        const patientinfo = {
          patient: pName,
          birthday: dateOfBirth,
          zip: patientdata?.zipcode ? patientdata.zipcode : "",
          ssn: patientdata?.ssn ? patientdata.ssn : "",
          age: patientdata?.age? patientdata.age: "",
          mrn: patientdata?.mrn? patientdata?.mrn: "",
          type:"Patient",
          location: patientdata?.address ?patientdata.address : "",
          id: patientdata?.id,
          key: patientdata?.id,
          selected:tempsubjectselected,
          gender: patientdata?.gender ? patientdata.gender : "",
        }
        patientmodaldata.push(patientinfo);
        //check if selected record for source
        if(source.selected && source.selected.id===patientdata.id){
          tempsourceselected=true;
        }
        const sourcepatientinfo = {
          patient: pName,
          birthday: dateOfBirth,
          zip: patientdata?.zipcode ? patientdata.zipcode : "",
          ssn: patientdata?.ssn ? patientdata.ssn : "",
          age: patientdata?.age? patientdata.age: "",
          mrn: patientdata?.mrn? patientdata?.mrn: "",
          type:"Patient",
          location: patientdata?.address ?patientdata.address : "",
          id: patientdata?.id,
          key: patientdata?.id,
          selected:tempsourceselected,
          gender: patientdata?.gender ? patientdata.gender : "",
        }
        if(searcheddata === sourcepatientinfo?.id && sourcepatientmodaldata.includes(searcheddata)) {
          //do nothing
        }
        else {
          sourcepatientmodaldata.push(sourcepatientinfo);
        }
      })
    }

  // format the Phone number
  let incomingnumber = (choosecaller?.number) ? choosecaller.number : "";
  if (incomingnumber?.length == 10) {
    // format phone (213) 506-789
    let rex= new RegExp(/(\d{3})(\d{3})(\d{4})/);
    incomingnumber = incomingnumber.replace(rex, "($1) $2-$3");
  }

  let flowButtonPhone = (
    <div className="p-verification__top-item is-success">
      <svg className="p-verification__panel" enableBackground="new 0 0 377.3 67.5" height="33" viewBox="0 0 377.3 67.5" width="188" xmlns="http://www.w3.org/2000/svg"><path className="p-verification__panel-bg" clipRule="evenodd" d="m355.9 1.1h-321.7s.7-.2 0 0c-17.7.2-33.2 14.9-33.2 32.7s15.2 32.5 32.9 32.7c.5.2 0 0 0 0h323l19.1-31.9z" fill="#d8d8d8" fillRule="evenodd" /><path className="p-verification__panel-border" d="m33.8 67.5c-18.4-.3-33.8-15.7-33.8-33.7s15.6-33.4 34.1-33.7l.1-.1v.1h322.2l20.8 34.5-19.7 32.9h-323.6v-.3.3zm.1-2h322.4l18.5-30.9-19.5-32.5h-321.1c-17.4.2-32.2 14.7-32.2 31.7s14.6 31.5 31.9 31.7z" fill="#979797" /></svg>
      <PhoneIncoming className="p-verification__top-item-ico" />
      <div className="p-verification__top-item-note">{incomingnumber}</div>
    </div>
  )
  let flowButtonSource = (
    <div className={`p-verification__top-item ${classNames({ 'is-active':skipsource?false:true })} ${classNames({ 'is-clickable':(!choosecaller.clicked && steps>0)?true:false })}`}
    onClick={(e) => {
      if (choosecaller.clicked) return
      if(steps>=1) {
          setSteps(0);
          setSkipSource(false);
      }
    }}>
      <svg className="p-verification__panel" enableBackground="new 0 0 379.7 67.4" height="67.4" viewBox="0 0 379.7 67.4" width="379.7" xmlns="http://www.w3.org/2000/svg"><path className="p-verification__panel-bg" d="m1.8 1 20 33.5-19 31.9h355.7l20-32.7-19.4-32.7z" fill="#c6c6c6" /><path className="p-verification__panel-border" d="m359.1 67.4h-358.1l19.6-32.9-20.6-34.5h359.7l20 33.7zm-354.6-2h353.4l19.4-31.7-18.8-31.7h-355l19.5 32.5z" fill="#979797" /></svg>
      { skipsource?( <BadgeAccount className="p-verification__top-item-ico" />):(<PhoneIncoming className="p-verification__top-item-ico" />)}
      <div className="p-verification__top-item-note">Verify Source</div>
    </div>
  )
  let dynamicicontype =(sel:any) => {
      if(sel){
        if(sel?.subtypename == "Nurse"){
          return ( <MotherNurse  className="p-verification__top-item-ico" />)
        }else if(sel?.subtypename == "Doctor"){
          return (<Doctor  className="p-verification__top-item-ico" />)
        }else if(Number(sel?.age) <=18){
          return (<HumanChild  className="p-verification__top-item-ico" />)
        }else if(sel?.gender == "Male"){
          return ( <HumanMale  className="p-verification__top-item-ico" />)
        }else if(sel?.gender == "Female"){
          return (<HumanFemale  className="p-verification__top-item-ico" />)
        }else if(sel?.typename == "Patient"){
          return (<HumanFemale  className="p-verification__top-item-ico" />)
        }
      } else{
        return(<></>)
      }
  }
  let selectedpName=(source?.selected?.preferredName?'"'+source?.selected?.preferredName+'"':'')
  let flowButtonSourceDynamic = (
    <div className={`p-verification__top-item is-success ${classNames({ 'is-active':steps===0?true:false })} ${classNames({ 'is-clickable': (!choosecaller.clicked && steps>0) ? true : false })}`}
        onClick={(event) => {
          if (choosecaller.clicked) return
          if(steps>=1) {
              setSteps(0);
              setSkipSource(false);
          }
      }}>
      <svg className="p-verification__panel" enableBackground="new 0 0 379.7 67.4" height="67.4" viewBox="0 0 379.7 67.4" width="379.7" xmlns="http://www.w3.org/2000/svg"><path className="p-verification__panel-bg" d="m1.8 1 20 33.5-19 31.9h355.7l20-32.7-19.4-32.7z" fill="#c6c6c6" /><path className="p-verification__panel-border" d="m359.1 67.4h-358.1l19.6-32.9-20.6-34.5h359.7l20 33.7zm-354.6-2h353.4l19.4-31.7-18.8-31.7h-355l19.5 32.5z" fill="#979797" /></svg>
      {dynamicicontype(source?.selected)}
      <div className="p-verification__top-item-note">{source?.selected?.lastname} {source?.selected?.firstname} {preferred_name?selectedpName:''}</div>
    </div>
  )
  let selectedSpName=(subjectselcted?.preferredName?'"'+subjectselcted?.preferredName+'"':'')
  let flowButtonSubject =(
    <div className={`p-verification__top-item ${classNames({ 'is-active':steps>0?true:false })} ${classNames({ 'is-clickable': (!choosecaller.clicked && steps>0) ? true : false })} `}
    onClick={(e) => {
      if (choosecaller.clicked) return
      if(steps>=0) {
          setSteps(1);
          setSkipSource(true);
      }
    }}>
    <svg className="p-verification__panel" enableBackground="new 0 0 379.4 67.4" height="67.4" viewBox="0 0 379.4 67.4" width="379.4" xmlns="http://www.w3.org/2000/svg"><path className="p-verification__panel-bg" d="m346.9 1c-.1 0-.1 0 0 0h-345.1l19.3 32.5-18.4 32.9h343.5.6c17.4 0 31.6-14.6 31.6-32.7s-14.1-32.7-31.5-32.7z" fill="#c6c6c6" /><path className="p-verification__panel-border" d="m346.9 67.4c-.1 0-.2 0-.4 0h-.3-345.2l18.9-33.9-19.9-33.5h347.4c17.7.3 32 15.3 32 33.7 0 18.6-14.6 33.7-32.5 33.7zm-.6-2h.3.3c16.9 0 30.6-14.2 30.6-31.7s-13.7-31.7-30.6-31.7h-.6-342.8l18.7 31.4-17.8 32h341.2z" fill="#979797" /></svg>
    <BadgeAccount className="p-verification__top-item-ico" />
    <div className="p-verification__top-item-note">Verify Subject</div>
  </div>
  )
  let flowButtonSubjectDynamic =(
    <div className={`p-verification__top-item is-success ${classNames({ 'is-active':steps===1?true:false })}`}>
    <svg className="p-verification__panel" enableBackground="new 0 0 379.4 67.4" height="67.4" viewBox="0 0 379.4 67.4" width="379.4" xmlns="http://www.w3.org/2000/svg"><path className="p-verification__panel-bg" d="m346.9 1c-.1 0-.1 0 0 0h-345.1l19.3 32.5-18.4 32.9h343.5.6c17.4 0 31.6-14.6 31.6-32.7s-14.1-32.7-31.5-32.7z" fill="#c6c6c6" /><path className="p-verification__panel-border" d="m346.9 67.4c-.1 0-.2 0-.4 0h-.3-345.2l18.9-33.9-19.9-33.5h347.4c17.7.3 32 15.3 32 33.7 0 18.6-14.6 33.7-32.5 33.7zm-.6-2h.3.3c16.9 0 30.6-14.2 30.6-31.7s-13.7-31.7-30.6-31.7h-.6-342.8l18.7 31.4-17.8 32h341.2z" fill="#979797" /></svg>
    {dynamicicontype(subjectselcted)}
    <div className="p-verification__top-item-note">{subjectselcted?.lastname} {subjectselcted?.firstname} {preferred_name?selectedSpName:''}</div>
  </div>
  )

  const contentOfFloater = (

    <Spin tip="Loading..."
      spinning={isLoading}>
      <div
        className="p-verification"
      // style={{width: verification_model_width-40 }}
      >
        <div className="p-verification__top">
          {flowButtonPhone}
          {source?.selected ? flowButtonSourceDynamic : flowButtonSource}
          {subjectselcted ? flowButtonSubjectDynamic : flowButtonSubject}
        </div>
        <div className="p-verification__box subject">
          <Skeleton loading={skeleton?.subject_skeleton} active title={true} paragraph={{ rows: 3 }}>
            <Table
              className="p-verification__table"
              columns={steps == 0 ? sourcepatientcolumns : patientcolumns}
              dataSource={steps == 0 ? sourcepatientmodaldata : patientmodaldata}
              scroll={{ y: steps == 0 ? 150 : 400 }}
              pagination={false}
              onRow={(record: any, event: any) => {
                return {
                  onClick: () => PatientOnSelect(record, false),
                };
              }}
            />
          </Skeleton>
        </div>

        {steps === 0 && (
          <div className="p-verification__box source">
            <Skeleton loading={skeleton?.source_skeleton} active paragraph={{ rows: 3 }}>
              <Table
                className="p-verification__table"
                columns={providercolumns}
                dataSource={sourcemodaldata}
                scroll={{ y: 150 }}
                pagination={false}
                onRow={(record: any, event: any) => {
                  return {
                    onClick: () => ProviderOnSelect(record, false),
                  };
                }}
              />
            </Skeleton>
          </div>
        )}

        <div className="p-verification__action">
          <div className="p-verification__action-main">
            <a
              className="p-verification__action-btn is-primary mr-15"
              onClick={(e) => {
                (search.patient || search.provider) && dispatch(globalSearchAction(true));
                (search.patient || search.provider) && dispatch(setPatientMatchFromAction(PatientMatchFrom.IDENTIFY_FLOW));
                (search.patient || search.provider) &&
                  dispatch({
                    type: 'one-state-choosecaller/set',
                    payload: {
                      number: choosecaller.number,
                      dnis: choosecaller.dnis,
                      visible: false,
                      clicked: choosecaller.clicked,
                    },
                  });
                steps == 0 && dispatch(sourceSearchAction(true));
              }}
            >
              <Magnify className="text-2xl mr-5" />
                  Search
                </a>
          </div>
          <div className="p-verification__action-second">
            <a
              className="p-verification__action-btn is-default"
              onClick={() => {
                // check for no records
                if (source?.values.length == 0 && subjects?.length == 0 && steps == 0) {
                  dispatch({
                    type: 'one-state-choosecaller/set',
                    payload: {
                      number: choosecaller.number,
                      dnis: choosecaller.dnis,
                      visible: true,
                      start: false,
                    },
                  });
                  setSkipSource(true);
                  setSteps(1);
                } else if (source?.values.length == 0 && subjects?.length == 1) {
                  dispatch({
                    type: 'one-state-choosecaller/set',
                    payload: {
                      number: choosecaller.number,
                      dnis: choosecaller.dnis,
                      visible: false,
                    },
                  });
                } else if (steps == 0 && choosecaller.start) {
                  setSkipSource(true);
                  setSteps(1);
                }
                // else if(steps == 1 && choosecaller.start){
                //   setSteps(2);
                // }
                else {
                  dispatchdata();
                }
              }}
            >
              {steps < 2 && choosecaller.start ? 'Skip' : 'Complete'}
            </a>
          </div>
        </div>
      </div>
    </Spin>
  );


  return (
    <div>
      {(contact_center_type && contact_center_type === 'wxcc') && (<Floater
      content={contentOfFloater}
      open={choosecaller?.visible}
      //style={{ left: patientverification_position }}
      styles={{
        floater: {
          maxWidth: verification_model_width,
          width: '100%'
        }
      }}
      hideArrow 
      placement="bottom"
      showCloseButton={true}
      >
        <div></div>
      </Floater>)}
      {(contact_center_type && contact_center_type !== 'wxcc') && (<Modal
        visible={choosecaller?.visible}
        footer={null}
        style={{ left: patientverification_position }}
        width={verification_model_width}
        closable={false}
        wrapClassName="custom-modal-wrap custom-choosepatient-wrap"
        destroyOnClose
        mask={true}
        maskClosable={true}
        onCancel={() => {
          console.log('Cancelled  ');
          dispatchdata();
        }}
      >
        { contentOfFloater }
      </Modal>)}
    </div>
  );
};